import { render, staticRenderFns } from "./TaskSESQuestion.vue?vue&type=template&id=072a4ca2&scoped=true&"
import script from "./TaskSESQuestion.vue?vue&type=script&lang=js&"
export * from "./TaskSESQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TaskSESQuestion.vue?vue&type=style&index=0&id=072a4ca2&lang=scss&scoped=true&"
import style1 from "./TaskSESQuestion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a4ca2",
  null
  
)

export default component.exports